import { render, staticRenderFns } from "./MediaGallery.vue?vue&type=template&id=041c83b0"
import script from "./MediaGallery.vue?vue&type=script&lang=js"
export * from "./MediaGallery.vue?vue&type=script&lang=js"
import style0 from "./MediaGallery.vue?vue&type=style&index=0&id=041c83b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports